import { of } from 'rxjs';

export const ctaMockData = {
  data$: of({
    title: 'CTA Editor: Lorem ipsum dolor sit amet',
    text: 'Ex galisum quidem eum quod iusto est nesciunt maxime non voluptas iusto non culpa quia. Vel explicabo nobis ut ullam architecto At velit dolorum rem assumenda expedita.',
    link: {
      url: '#',
      linkName: 'Get in touch',
      target: '_blank',
    },
  }),
};

export const ctaMockDataQA = {
  data$: of({
    uid: 'cmsitem_00193017',
    uuid: 'eyJpdGVtSWQiOiJjbXNpdGVtXzAwMTkzMDE3IiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
    typeCode: 'CtaComponent',
    modifiedtime: '2022-11-17T16:14:11.83+01:00',
    name: 'CTA1',
    container: false,
    removeBottomSpacing: true,
    synchronizationBlocked: false,
    link: {
      container: false,
      contentPage: 'cmsitem_00024030',
      uuid: 'eyJpdGVtSWQiOiJjbXNpdGVtXzAwMDI0MDM2IiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
      contentPageLabelOrId: '/bouwmaatpas',
      linkName: 'Renting on account',
      url: '/bouwmaatpas',
      typeCode: 'CMSLinkComponent',
      target: false,
      uid: 'cmsitem_00024036',
      external: true,
      name: 'Huren op rekening - Link',
      synchronizationBlocked: false,
      parents: 'cmsitem_00193004 cmsitem_00193010',
    },
    text: 'Bottom removed',
    title: 'CTA Editor: Lorem ipsum dolor sit amet.',
  }),
};
